import { useRoutes, useLocation } from "react-router-dom";
import routes from "./routes/routes";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./ScrollToTop";
import "./assets/globalStyles/styles.scss";
import { AnimatePresence, motion } from "framer-motion";
import { CommmunityNotificationProvider } from "./Context/notificationContext";

const App = () => {
  const content = useRoutes(routes);
  const location = useLocation(); // ✅ Get the current location

  return (

<>
<CommmunityNotificationProvider>
<ScrollToTop />

  {content}
  <Toaster />
  </CommmunityNotificationProvider>
  </>

  );
};

export default App;
